import {CustomerService} from "@/services/business/CustomerService";
import {AuthContext} from "@/context/AuthContext";
import {Storage} from "@/models/facade/Storage";
import {LocalStorageKeyEnum} from "@/models/enum/LocalStorageKeyEnum";
import {AuthInfoModel} from "@/models/AuthInfoModel";
import {Config} from "@/models/facade/Config";

function fetchJwt(idToken) {
    const tokenParts = idToken.split('.');
    const encodedPayload = tokenParts[1];
    const rawPayload = atob(encodedPayload);
    return JSON.parse(rawPayload);
}

function buildUser(idToken) {
    const jwt = fetchJwt(idToken);

    return {first_name: jwt.name, last_name: jwt.family_name};
}

export default {
    state() {
        return {
            authInfo: AuthInfoModel.createWithDefaults()
        };
    },
    actions: {
        async handleOAuth2V2Callback(context, payload) {
            const token = payload.token;

            context.commit("setAuthInfo", new AuthInfoModel(
                null,
                buildUser(token.idToken),
                token.idToken,
                false
            ));
        },
        changeCustomer(context, customer_code) {
            if (!customer_code) {
                customer_code = context.getters.getCurrentCustomerCode;
            }

            if (!customer_code) {
                const tenants = AuthContext.getTenants();

                if (tenants.length > 0) {
                    customer_code = tenants[0]['customer_code'];
                } else if (AuthContext.isDpUser()) {
                    customer_code = Config.getInstance().getConfig().ADMIN_CUSTOMER_CODE;
                }
            }

            context.commit("setCurrentCustomerCode", customer_code);
            CustomerService.getInstance().changeCustomerHook(customer_code);
        },
        autoLogout(context) {
            context.commit('setAutoLogout');
        }
    },
    mutations: {
        setCurrentCustomerCode(state, customer_code) {
            state.authInfo.currentCustomerCode = customer_code;

            Storage.local.set(LocalStorageKeyEnum.CURRENT_CUSTOMER_CODE, customer_code);
        },
        setAuthInfo(state, authInfo) {
            state.authInfo = authInfo;
        },
        setAutoLogout(state) {
            state.authInfo.currentCustomerCode = null;
            state.authInfo.idToken = null;
            state.authInfo.didAutoLogout = true;
        }
    },
    getters: {
        getCurrentCustomerCode(state) {
            return state.authInfo.currentCustomerCode;
        },
        isAuthenticated(state) {
            return !!state.authInfo.idToken;
        },
        didAutoLogout(state) {
            return state.authInfo.didAutoLogout;
        }
    }
};
